import logo from './logo.svg';
import './App.css';

function Education({ section, setSection }) {

    return (
        <>
            {/* ======= Education Section ======= */}
            <section id="education" className={`resume ${section == "education" ? "section-show" : ""}`}>
                <div className="container">
                    <div className="section-title">
                        <h2>Education</h2>
                        <p>Journey Through My Education</p>
                    </div>
                    <div className="row">

                        <div className="col-lg-6">
                            <div className="resume-item mb-5 pb-0">
                                <h4>Chandigarh College of Engineering &amp; Technology</h4>
                                <h5>2016 - 2019</h5>
                                <p className='mt-2 mb-1'>Computer Science Engineering, Diploma (C.S.E) - 3 Years</p>
                                <p><em>Chandigarh, India</em></p>
                            </div>
                            <div className="resume-item mb-4">
                                <h4>12<sup>th</sup> Class - C.B.S.E Board </h4>
                                <h5>2012 - 2014</h5>
                                <p className='mt-2 mb-1'> Stenography and Computer Applications </p>
                                <p><em>Chandigarh, India</em></p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="resume-item mb-5">
                                <h4>Industrial Training Institute (I.T.I)</h4>
                                <h5>2014 - 2015</h5>
                                <p className='mt-2 mb-1'>Computer Operator &amp; Programming Assistant (C.O.P.A) </p>
                                <p><em>Chandigarh, India</em></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* End Education Section */}
        </>
    );
}

export default Education;
